import { render, staticRenderFns } from "./DialogLoader.vue?vue&type=template&id=2ceb206c"
import script from "./DialogLoader.vue?vue&type=script&lang=js"
export * from "./DialogLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports